<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0 ma-0">
      <v-tabs
        v-model="tab"
        centered
        grow
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-if="mostrarVista(34)"
          href="#mastografos"
          @click="actualizarItems('mastografos')"
        >
          Mastógrafos
        </v-tab>

        <v-tab
          v-if="mostrarVista(34)"
          href="#asignacion_estudios"
          @click="actualizarItems('asignacion_estudios')"
        >
          Estudios de Imagen<br>Sin Asociación
        </v-tab>

        <v-tab
          v-if="mostrarVista(34)"
          href="#asignacion_interpretaciones"
          @click="actualizarItems('asignacion_interpretaciones')"
        >
          Asignación de<br>Interpretaciones Radiológicas
        </v-tab>

        <v-tab
          v-if="mostrarVista(35)"
          href="#interpretaciones_radiologicas"
          @click="actualizarItems('interpretaciones_radiologicas')"
        >
          Interpretaciones <br> Radiológicas
        </v-tab>

        <v-tab
          v-if="mostrarVista(37)"
          href="#descargar_interpretacion_radiologica"
          @click="actualizarItems('descargar_interpretacion_radiologica')"
        >
          Descarga de Resultados <br> de Mastografía
        </v-tab>

        <v-tab
          v-if="mostrarVista(38)"
          href="#concentrado_interpretaciones"
          @click="actualizarItems('concentrado_interpretaciones')"
        >
          Concentrado de <br> Interpretaciones
        </v-tab>
      </v-tabs>
          
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-if="mostrarVista(34)"
          value="mastografos"
        >
          <Mastografos
            ref="mastografos"
          ></Mastografos>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(34)"
          value="asignacion_estudios"
        >
          <AsignacionEstudios
            ref="asignacion_estudios"
          ></AsignacionEstudios>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(34)"
          value="asignacion_interpretaciones"
        >
          <AsignacionInterpretaciones
            ref="asignacion_interpretaciones"
          ></AsignacionInterpretaciones>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(35)"
          value="interpretaciones_radiologicas"
        >
          <InterpretacionesRadiologicas
            ref="interpretaciones_radiologicas"
          ></InterpretacionesRadiologicas>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(37)"
          value="descargar_interpretacion_radiologica"
        >
          <DescargarImagenesISO
            ref="descargar_interpretacion_radiologica"
          >
          </DescargarImagenesISO>
        </v-tab-item>

        <v-tab-item
          v-if="mostrarVista(38)"
          value="concentrado_interpretaciones"
        >
          <ConcentradoInterpretaciones
            ref="concentrado_interpretaciones"
          >
          </ConcentradoInterpretaciones>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import AsignacionEstudios from './ConsultaMastografia/AsignacionEstudios.vue'
import AsignacionInterpretaciones from './ConsultaMastografia/AsignacionInterpretaciones.vue'
import InterpretacionesRadiologicas from './ConsultaMastografia/InterpretacionesRadiologicas.vue'
import Mastografos from './ConsultaMastografia/Mastografos.vue'
import DescargarImagenesISO from './ConsultaMastografia/DescargarImagenesISO.vue'
import ConcentradoInterpretaciones from './ConsultaMastografia/ConcentradoInterpretaciones.vue'

export default {
  computed: {
    ...mapState(['ids_vistas'])
  },
  components:{
    AsignacionEstudios,
    AsignacionInterpretaciones,
    InterpretacionesRadiologicas,
    Mastografos,
    DescargarImagenesISO,
    ConcentradoInterpretaciones
  },
  data: () => ({
    tab: null
  }),
  methods: {
    mostrarVista(id_vista){
      if(this.ids_vistas == null || this.ids_vistas.length == 0) return false;
      return (this.ids_vistas.indexOf(id_vista) >= 0);
    },
    actualizarItems(refName) {
      if (this.$refs[refName] && this.$refs[refName].getItems) {
        this.$refs[refName].getItems();
      } else {
        console.warn(`No se encontró la referencia: ${refName}`);
      }
    }
  }
}
</script>